import { useTranslation } from "react-i18next";
import CustomText from "components/Atoms/CustomText/CustomText";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { InstitutionContact } from "./InstitutionsContactModel";
import { Column, ContactCardContentWrapper, ContactCardTitleWrapper, ContactCardWrapper } from "./InstitutionsContactStyled";

interface ContactFieldProps {
  field: string;
  label: string;
  values: string[];
  link?: boolean;
}

const ContactField = ({ field, label, values, link }: ContactFieldProps) => (
  <Column data-contact-field={field}>
    <dt><CustomText type={TextType.P2} text={label} color={COLORS.Gunmetal} /></dt>
    <dd>
      {values.length ? values.map((value, index) => (
        link ? (
          <a key={index} href={value} target="_blank" rel="noreferrer">
            <CustomText type={TextType.H4} text={value} color={COLORS.RaisinBlack} />
          </a>
        ) : (
          <CustomText key={index} type={TextType.H4} text={value} color={COLORS.RaisinBlack} />
        )
      )) : <CustomText type={TextType.H4} text="—" color={COLORS.MetalicSilver} />}
    </dd>
  </Column>
);

const InstitutionContactCard = ({ contact, showWebsite }: { contact: InstitutionContact; showWebsite: boolean }) => {
  const { t } = useTranslation();
  return (
    <ContactCardWrapper as="article" aria-label={contact.name} data-institution-contact>
      <ContactCardTitleWrapper>
        <CustomText type={TextType.H4bold} text={contact.name} color={COLORS.VividAuburn} />
      </ContactCardTitleWrapper>
      <ContactCardContentWrapper>
        <ContactField field="address" label={t("view.about.contactInstitutions.adress")}
          values={contact.address ? [contact.address] : []} />
        <ContactField field="phone" label={t("view.about.contactInstitutions.phone")} values={contact.phones} />
        <ContactField field="email" label={t("view.about.contactInstitutions.email")} values={contact.emails} />
        {showWebsite && <ContactField field="website" label={t("view.about.contactInstitutions.website")}
          values={contact.website ? [contact.website] : []} link />}
      </ContactCardContentWrapper>
    </ContactCardWrapper>
  );
};

export default InstitutionContactCard;
